/* MOF 2026-11-02 (Simon; Jay: OBEX fabrics past Shopify's 250-variant cap).
   Shopify hands a theme at most 250 variants in [data-variant-json]. When snippets/product-form.liquid sees the cap
   it also emits [data-mof-hv-options], a map of option value name -> option value id. For such a product this file:
   1. on a picker change whose combination is not in the theme's list, stops the theme's handler, asks Shopify's
      Section Rendering API for the same product section with ?option_values=<ids>, reads the variant it rendered,
      adds it to the theme's list and re-fires the change, so price, photo, SKU, URL, inventory and Add to Cart
      behave exactly as for a listed variant;
   2. keeps off-list option values selectable (the theme greys out any value it cannot find in its list) and only
      crosses out a value when a listed variant for that exact combination is sold out;
   3. seeds the list from [data-current-variant-json] when a deep link lands on an off-list variant.
   Hooks are event-level, so they work whether this file runs before or after the theme initialises the section.
   Products under the cap have no map and are untouched. Docs: shopify.dev themes/product-merchandising/variants/support-high-variant-products */
(function () {
  'use strict';
  var KEYS = ['option1', 'option2', 'option3'];
  var SECTION = '[data-section-type="product"]';

  function mapFor(container) {
    if (!container || !container.querySelector) return null;
    var el = container.querySelector('[data-mof-hv-options]');
    if (!el) return null;
    if (el.__mofMap === undefined) {
      try { el.__mofMap = JSON.parse(el.textContent); } catch (e) { el.__mofMap = null; }
    }
    return el.__mofMap;
  }

  function instanceFor(container) {
    var S = window.theme && theme.sections;
    var list = (S && S.instances) || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].container === container && list[i].variants) return list[i];
    }
    return null;
  }

  function ensureSelectOption(container, v) {
    var sel = container.querySelector('[data-product-select]');
    if (!sel || !v || !v.id) return;
    if (sel.querySelector('option[value="' + v.id + '"]')) return;
    var o = document.createElement('option');
    o.value = v.id;
    o.textContent = v.title || v.id;
    sel.appendChild(o);
  }

  function learn(inst, v) {
    var list = inst.variantsObject || inst.variants.variants;
    if (!v || !v.id || !list) return false;
    if (!list.some(function (x) { return x.id === v.id; })) list.push(v);
    ensureSelectOption(inst.container, v);
    return true;
  }

  /* 2. Availability: off-list values stay selectable; only a listed sold-out combination is crossed out. */
  function fixAvailability(container, variant) {
    var map = mapFor(container);
    var inst = instanceFor(container);
    if (!map || !inst) return;
    var list = inst.variantsObject || inst.variants.variants || [];
    var cur = variant || inst.variants.currentVariant || {};
    KEYS.forEach(function (k) {
      var group = container.querySelector('.variant-input-wrap[data-index="' + k + '"]');
      if (!group || !map[k]) return;
      var isDropdown = group.querySelector('select') && !group.querySelector('.variant-input');
      Object.keys(map[k]).forEach(function (name) {
        var hit = list.filter(function (x) {
          return x[k] === name && KEYS.every(function (j) { return j === k || !cur[j] || x[j] === cur[j]; });
        })[0];
        var soldOut = !!(hit && hit.available === false);
        if (isDropdown) {
          group.querySelectorAll('option').forEach(function (o) { if (o.value === name) o.disabled = false; });
        } else {
          group.querySelectorAll('.variant-input').forEach(function (b) {
            if (b.getAttribute('data-value') !== name) return;
            b.querySelectorAll('input,label').forEach(function (el) { el.classList.toggle('disabled', soldOut); });
          });
        }
      });
    });
  }

  /* 1. Picker change on an off-list combination: resolve through the Section Rendering API, then re-fire. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (e.__mofHV || !input || !input.matches || !input.matches('[data-variant-input]')) return;
    var container = input.closest(SECTION);
    var map = container && mapFor(container);
    if (!map) return;
    var inst = instanceFor(container);
    if (!inst) return;
    var V = inst.variants;
    if (V._getVariantFromOptions()) return; /* listed: the theme handles it */

    var selected = V._getCurrentOptions();
    var ids = selected.map(function (o) { var m = map[o.index]; return m ? m[o.value] : null; });
    var handle = container.getAttribute('data-product-handle');
    var sectionId = container.getAttribute('data-section-id');
    if (!ids.length || ids.some(function (x) { return !x; }) || !handle || !sectionId) return;

    e.stopImmediatePropagation(); /* the theme's own listener would show Unavailable */
    var key = ids.join(',');
    inst.__mofPending = key;
    var btnText = container.querySelector('[data-add-to-cart-text]');
    if (btnText) btnText.textContent = 'Loading...';

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root + 'products/' + encodeURIComponent(handle) +
      '?section_id=' + encodeURIComponent(sectionId) + '&option_values=' + key;

    function refire() {
      var ev = new Event('change', { bubbles: true });
      ev.__mofHV = true;
      input.dispatchEvent(ev);
    }

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        if (inst.__mofPending !== key) return; /* a newer click superseded this one */
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ta = doc.querySelector('[data-current-variant-json]');
        var v = ta ? JSON.parse(ta.textContent) : null;
        var matches = !!v && selected.every(function (o) { return v[o.index] === o.value; });
        if (matches) learn(inst, v);
        refire(); /* resolves now, or stays unknown and the theme shows Unavailable */
      })
      .catch(function () {
        if (inst.__mofPending !== key) return;
        refire();
      });
  }, true);

  function install() {
    document.querySelectorAll(SECTION).forEach(function (container) {
      if (container.__mofHV || !mapFor(container)) return;
      var inst = instanceFor(container);
      if (!inst) return;
      container.__mofHV = true;
      /* 3. Deep link to an off-list variant: seed the list and the theme's current variant. */
      try {
        var cur = container.querySelector('[data-current-variant-json]');
        var v = cur ? JSON.parse(cur.textContent) : null;
        if (v && v.id && learn(inst, v) && !inst.variants.currentVariant) inst.variants.currentVariant = v;
      } catch (err) {}
      container.addEventListener('variantChange', function (ev) {
        fixAvailability(container, ev.detail && ev.detail.variant);
      });
      fixAvailability(container, null);
    });
  }

  install();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install);
  window.addEventListener('load', install);
  /* quick-view modals create their product section later */
  document.addEventListener('quickview:loaded', install);
  setTimeout(install, 1500);
})();
